import React from 'react';
import { Button } from 'gatorcomponents';
import * as Styles from './EmptyProducts.styles';
import HGImageProductHosting from './HGImageProductHosting';
import HGImageProductDomain from './HGImageProductDomain';
import { HOSTING_URL } from '@/config/urls/hostingUrls';
import { REGISTER_DOMAIN_URL } from '@/config/urls/domainsUrls';
import { homeAnalytics } from '@/analytics/home';

const EmptyProducts = ({
  variant, title, subtitle, buttonLabel, size,
}) => {
  const getImage = () => {
    switch (variant) {
      case 'hosting':
        return <HGImageProductHosting />;
      case 'domain':
        return <HGImageProductDomain />;
      default:
        return null;
    }
  };

  const getButtonAction = (variant) => {
    switch (variant) {
      case 'hosting':
        homeAnalytics.contractedHostingsHireClick();
        return (window.open(HOSTING_URL, '_blank'));
      case 'domain':
        homeAnalytics.contractedDomainsHireClick();
        return (window.open(REGISTER_DOMAIN_URL, '_blank'));
      default:
        return null;
    }
  };

  return (
    <Styles.CardEmpty>
      <Styles.WrapperImage width={size}>
        {getImage()}
      </Styles.WrapperImage>

      <Styles.WrapperDescription>
        <Styles.CardEmptyTitle data-testid="cardEmptyTitle">
          {title}
        </Styles.CardEmptyTitle>

        <Styles.CardEmptySubtitle data-testid="cardEmptySubtitle">
          {subtitle}
        </Styles.CardEmptySubtitle>

        <Button
          label={buttonLabel}
          onClick={() => getButtonAction(variant)}
          size="medium"
          testId="button"
          title={buttonLabel}
          type="button"
          variant="secondary"
          version="v2"
          width="fit-content"
        />
      </Styles.WrapperDescription>
    </Styles.CardEmpty>
  );
};

export default EmptyProducts;
